import { render, staticRenderFns } from "./NexultraLMarketingCampaign.vue?vue&type=template&id=451fd2b2&scoped=true&"
import script from "./NexultraLMarketingCampaign.vue?vue&type=script&lang=js&"
export * from "./NexultraLMarketingCampaign.vue?vue&type=script&lang=js&"
import style0 from "./NexultraLMarketingCampaign.vue?vue&type=style&index=0&id=451fd2b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451fd2b2",
  null
  
)

export default component.exports